var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.499 14.5c0 .254-.162.585-.665.963-.494.372-1.24.728-2.208 1.035-1.93.614-4.626 1.002-7.627 1.002-3 0-5.697-.388-7.627-1.002-.967-.308-1.714-.664-2.208-1.035-.503-.378-.665-.709-.665-.963s.162-.585.665-.963c.494-.372 1.24-.728 2.208-1.035C5.302 11.888 7.998 11.5 11 11.5c3 0 5.697.388 7.627 1.002.967.307 1.714.663 2.208 1.035.503.378.665.709.665.963z",
    stroke: "#9D9D9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.598 5.17c0 1.298-.642 3.053-1.617 4.799-.874 1.566-1.98 3.06-3.015 4.121-1.137-1.052-2.24-2.544-3.085-4.114-.933-1.736-1.51-3.497-1.51-4.805C6.37 2.586 8.44.5 10.983.5c2.543 0 4.614 2.086 4.614 4.67z",
    stroke: "#9D9D9D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.998,
    cy: 5.1,
    r: 1.45,
    stroke: "#9D9D9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.bac8db02.svg";
export { ForwardRef as ReactComponent };